import React, { useEffect, useState, useContext } from 'react';
import { Chip } from '@mui/material';
import './Restaurant.scss';
import AtomicButton from '../../../atomic/button/AtomicButton';
import Loader from '../../../composed/Loader/Loader';
import fallBackImage from '../../../global/assets/png/clock-blue.png';
import { MealOfferingCalculation } from './../../../global/calculations';
import { STORE_CLOSED_SHORT_TIME } from '../../../global/assets/Icons';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import { isValidAptNo } from './../../../utils/validation';
import { GlobalStateDataContext } from '../../../context-api/GlobalStateDataProvider';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import FavoriteIcon from '@mui/icons-material/Favorite';

const RestaurantsMobile = (props) => {
  const {
    filteredRestaurantList,
    handleClickRedirect,
    customerInfoData,
    setFilteredRestaurantList,
  } = props;
  const { urlValidationResponse } = useContext(GlobalStateDataContext);
  const [resturants, setResturants] = useState([]);
  const tempList = filteredRestaurantList.slice(0, 3);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState([]);
  const [imageError, setImageError] = useState([]);
  const [load, setLoad] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const custMealPlan = custInfoData?.meal_Package?.meal_plan;
  const [searchInputActive, setSearchInputActive] = useState(false);

  const BaseObj = urlValidationResponse?.data?.data?.data?.promoCodeValidation;
  const InvestorPartnerId = data?.data?.user_Info?.invest_one?.partner_id || null;
  const FilterPromoOwner = BaseObj?.promoCodeOwner === 'kitchen' ? BaseObj?.createdBy : null;

  const NegativeReview = false;
  const YourFirstChoice = () => {
    if (NegativeReview) {
      return null;
    } else {
      return FilterPromoOwner || InvestorPartnerId;
    }
  };

  const GetFirstChoiceOnTop = (RestaurantList) => [
    ...(RestaurantList.filter((item) => item.kitchenName === YourFirstChoice()) || []),
    ...(RestaurantList.filter((item) => item.kitchenName !== YourFirstChoice()) || []),
  ];

  const onSearch = (e) => {
    e.preventDefault();

    if (e.target.value.length > 0) {
      setSearchInputActive(true);
    } else {
      setSearchInputActive(false);
    }

    let hasError = false;
    if (e.target.value.length > 0) {
      hasError = !isValidAptNo(e.target.value);
    }

    if (hasError) {
      setValidationError(true);
      return;
    }

    if (e.target.value.length > 0) {
      setSearchInputActive(true);
    } else {
      setSearchInputActive(false);
    }

    setValidationError(false);
    const results =
      e.target.value.length > 0
        ? filteredRestaurantList.filter((el) => {
            return (
              el.display_name?.toLowerCase().indexOf(e.target.value?.toLowerCase()) >= 0 ||
              el.search_key_words?.find((keyword) =>
                keyword.includes(e.target.value?.toLowerCase())
              )
            );
          })
        : filteredRestaurantList;

    setResturants(GetFirstChoiceOnTop(results));
  };

  useEffect(() => {
    setImageLoaded([]);
    setImageError([]);
    setLoad(true);
    setResturants(GetFirstChoiceOnTop(filteredRestaurantList));
  }, [JSON.stringify(filteredRestaurantList)]);

  useEffect(() => {
    if (load) {
      setLoad(false);
    }
  }, [load]);

  const onLoadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setShowLoadMoreButton(false);
    }, 3000);
  };

  const onImageLoad = (index) => {
    setImageLoaded((prev) => {
      prev[index] = true;
      return [...prev];
    });
  };

  const onImageError = (index) => {
    setImageError((prev) => {
      prev[index] = true;
      return [...prev];
    });

    setImageLoaded((prev) => {
      prev[index] = true;
      return [...prev];
    });
  };

  // You will see Loader on some Images boxes bcoz display_image = null its coming

  return (
    <div className='restaurant-container-mobile'>
      <div className='restaurant-sub-title-mobile'>
        <div
          style={{
            color: '#181436',
            marginLeft: '10px',
            fontFamily: 'Inter Medium',
            fontSize: '16px',
          }}
        >
          Restaurants
        </div>
        <input
          type='search'
          placeholder='Search for food, restaurant ...'
          onChange={onSearch}
          style={{
            width: '200px',
            height: '20px',
            marginRight: '5px',
            fontFamily: 'Inter Regular',
            backgroundColor: 'white',
            border: '1px solid #DBD6D6',
            borderRadius: '3px',
            fontSize: '16px',
          }}
        />
        {/* {validationError && <div style={{ color: 'red' }}>Text format error</div>} */}
        {/* <AtomicDropdownMenu /> */}
      </div>
      {isLoading && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            background: 'rgb(0,0,0,0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {' '}
          <Loader color='black' />{' '}
        </div>
      )}

      {!load &&
        (showLoadMoreButton ? resturants.slice(0, 3) : resturants).map((el, index) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              height: 'auto',
              overflow: 'hidden',
              margin: '10px 10px 0px 10px',
              textTransform: 'capitalize',
              cursor: el.storeIsClosedForShortTime ? 'default' : 'pointer',
              background:
                el?.delivery_driver_shortage?.driver_shortage && el?.delivered_by !== 'kitchen'
                  ? '#F1F1F1'
                  : 'none',
              border:
                el?.delivery_driver_shortage?.driver_shortage && el?.delivered_by !== 'kitchen'
                  ? '1px solid rgb(0, 0, 0 ,0.1)'
                  : 'none',
              borderRadius: '5px',
              opacity:
                el?.delivery_driver_shortage?.driver_shortage && el?.delivered_by !== 'kitchen'
                  ? '0.7'
                  : 'none',
            }}
            key={el.kitchenName}
            onClick={el.storeIsClosedForShortTime ? null : (e) => handleClickRedirect(e, el)}
          >
            <div
              style={{
                border: '1px  solid #F1F1F1',
                height: '65px',
                width: '65px',
                margin: '2px',
                borderRadius: '5px',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                objectFit: 'cover',
              }}
            >
              <img
                width={imageLoaded[index] ? '100%' : 0}
                src={imageError[index] ? fallBackImage : el.display_image}
                onLoad={() => onImageLoad(index)}
                onError={() => onImageError(index)}
                key={el._id}
              />
              {!imageLoaded[index] && <Loader color='black' width='20px' height='20px' />}
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                margin: '0px 0px 5px 10px',
                width: '70%',
                position: 'relative',
              }}
            >
              {el?.delivery_driver_shortage?.driver_shortage && el?.delivered_by !== 'kitchen' && (
                <div
                  style={{
                    display: 'flex',
                    background: '#181436',
                    fontFamily: 'Inter Light',
                    fontSize: '12px',
                    letterSpacing: '0.5px',
                    borderRadius: '5px',
                    color: 'white',
                    width: '100px',
                    height: '30px',
                    position: 'absolute',
                    justifyContent: 'center',
                    alignItems: 'center',
                    top: '30%',
                    left: '18%',
                    opacity: 'none',
                    textTransform: 'none',
                  }}
                >
                  {' '}
                  Pick it up
                </div>
              )}
              {el.storeIsClosedForShortTime && (
                <img style={{ width: '50px' }} src={STORE_CLOSED_SHORT_TIME} alt=''></img>
              )}
              <div
                style={{
                  fontFamily: 'Inter Medium',
                  fontSize: '18px',
                  letterSpacing: '0.5px',
                  fontWeight: 600,
                  color: '#181436',
                  textTransform: 'capitalize',
                }}
              >
                {' '}
                {el.display_name || el.kitchenName}
                <span
                  style={{
                    fontFamily: 'Inter Regular',
                    fontSize: '13px',
                    fontWeight: 400,
                    color: '#707070',
                    marginLeft: '5px',
                    textTransform: 'capitalize',
                  }}
                >
                  {el.cuisine}
                </span>
                <span
                  style={{
                    fontFamily: 'Inter Regular',
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#181436',
                    marginLeft: '5px',
                    textTransform: 'none',
                  }}
                >
                  | {el.distanceAndETA?.roadMiles || 0} mi
                </span>
              </div>

              {YourFirstChoice() === el.kitchenName && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '10px',
                    fontFamily: 'Inter Medium',
                    color: '#FF7A28',
                    padding: '0px',
                    border: '2px solid #FF7A28',
                    margin: '5px 0px 5px 0px',
                    borderRadius: '3px',
                    width: '120px',
                    color: 'black',
                  }}
                >
                  {' '}
                  <FavoriteIcon sx={{ color: '#FF7A28', fontSize: '13px', marginRight: '5px' }} />
                  <div> Your First Choice</div>
                </div>
              )}
              <div
                style={{
                  fontSize: '13px',
                  fontFamily: 'Inter Regular',
                  flexWrap: 'wrap',
                  letterSpacing: '0.5px',
                  color: '#707070',
                  margin: '2px 5px 5px 0px',
                }}
              >
                {' '}
                Dummy Discription Dummy Discription Dummy Discription Dummy Discription Dummy
                Discription
              </div>

              <div
                style={{
                  fontFamily: 'Inter Regular',
                  fontSize: '12px',
                  color: '#D3D5DA',
                  margin: '3px 5px 2px 0px',
                }}
              >
                {' '}
                Rating & Reviews ( Coming soon )
              </div>

              {el.subscriptionMenuAvailable && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: '3px',
                    marginLeft: '0px',
                    marginTop: '5px',
                  }}
                >
                  <FastfoodIcon
                    sx={{ color: 'rgb(51, 167, 84)', fontSize: '15px', marginRight: '5px' }}
                  />

                  <div
                    style={{
                      fontSize: '13px',
                      fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
                      letterSpacing: '0.5px',
                      color: 'rgb(51, 167, 84)',
                    }}
                  >
                    Combo bundle
                  </div>

                  <Chip
                    label='Huge Saving'
                    size='medium'
                    sx={{
                      border: '1px solid #86c49a',
                      background: '#dff5cf',
                      color: '#06763f',
                      height: '20px',
                      fontSize: '13px',
                      fontFamily: 'Inter Regular',
                      marginLeft: '10px',
                    }}
                  />
                </div>
              )}

              {el.subscriptionMenuAvailable && (
                <div
                  style={{
                    display: 'flex',
                    marginBottom: '10px',
                    flexWrap: 'wrap',
                    marginLeft: '20px',
                  }}
                >
                  {el.meal_offering?.main_dish !== 0 &&
                    el.meal_offering?.main_dish !== undefined && (
                      <div
                        style={{
                          display: 'flex',
                          fontSize: '12px',
                          fontFamily: 'Inter Medium',
                          letterSpacing: '0.5px',
                          color: 'black',
                        }}
                      >
                        {`${MealOfferingCalculation({
                          CustomerMealPackage: custMealPlan,
                          KitchenMealOffering: el.meal_offering?.main_dish,
                        })}`}{' '}
                        {el.meal_offering?.main_dish >= 2 ? 'Main dishes' : 'Main dish'} + &nbsp;
                      </div>
                    )}

                  {el.meal_offering?.starter !== 0 && el.meal_offering?.starter !== undefined && (
                    <div
                      style={{
                        display: 'flex',
                        fontSize: '12px',
                        fontFamily: 'Inter Medium',
                        letterSpacing: '0.5px',
                        color: 'black',
                      }}
                    >
                      {`${MealOfferingCalculation({
                        CustomerMealPackage: custMealPlan,
                        KitchenMealOffering: el.meal_offering?.starter,
                      })}`}{' '}
                      {el.meal_offering?.starter >= 2 ? 'Starters' : 'Starter'} + &nbsp;
                    </div>
                  )}

                  {el.meal_offering?.side !== 0 && el.meal_offering?.side !== undefined && (
                    <div
                      style={{
                        display: 'flex',
                        fontSize: '12px',
                        fontFamily: 'Inter Medium',
                        letterSpacing: '0.5px',
                        color: 'black',
                      }}
                    >
                      {`${MealOfferingCalculation({
                        CustomerMealPackage: custMealPlan,
                        KitchenMealOffering: el.meal_offering?.side,
                      })}`}{' '}
                      {el.meal_offering?.side >= 2 ? 'Sides' : 'Side'} + &nbsp;
                    </div>
                  )}

                  {el.meal_offering?.power_side !== 0 &&
                    el.meal_offering?.power_side !== undefined && (
                      <div
                        style={{
                          display: 'flex',
                          fontSize: '12px',
                          fontFamily: 'Inter Medium',
                          letterSpacing: '0.5px',
                          color: 'black',
                        }}
                      >
                        {`${MealOfferingCalculation({
                          CustomerMealPackage: custMealPlan,
                          KitchenMealOffering: el.meal_offering?.power_side,
                        })}`}{' '}
                        {el.meal_offering?.power_side >= 2 ? 'Jumbo Sides' : 'Jumbo Side'} + &nbsp;
                      </div>
                    )}

                  {el.meal_offering?.drink_dessert_treat !== 0 &&
                    el.meal_offering?.drink_dessert_treat !== undefined && (
                      <div
                        style={{
                          display: 'flex',
                          fontSize: '12px',
                          fontFamily: 'Inter Medium',
                          letterSpacing: '0.5px',
                          color: 'black',
                        }}
                      >
                        {`${MealOfferingCalculation({
                          CustomerMealPackage: custMealPlan,
                          KitchenMealOffering: el.meal_offering?.drink_dessert_treat,
                        })}`}{' '}
                        {el.meal_offering?.drink_dessert_treat >= 2
                          ? 'Drinks or Dessert treats'
                          : 'Drink or Dessert treat'}{' '}
                        + &nbsp;
                      </div>
                    )}

                  {el.meal_offering?.complementary !== 0 &&
                    el.meal_offering?.complementary !== undefined && (
                      <div
                        style={{
                          display: 'flex',
                          fontSize: '12px',
                          fontFamily: 'Inter Medium',
                          letterSpacing: '0.5px',
                          color: 'black',
                        }}
                      >
                        {' '}
                        {`${MealOfferingCalculation({
                          CustomerMealPackage: custMealPlan,
                          KitchenMealOffering: el.meal_offering?.complementary,
                        })} `}{' '}
                        {el.meal_offering?.complementary >= 2 ? 'Complementaries' : 'Complementary'}{' '}
                        &nbsp;
                      </div>
                    )}
                </div>
              )}

              {searchInputActive && el.search_key_words?.length > 0 && (
                <div
                  style={{
                    border: '1px solid #DBD6D6',
                    letterSpacing: '0.4px',
                    flexWrap: 'wrap',
                    width: '250px',
                    borderRadius: '3px',
                    padding: '3px',
                    color: '#181436',
                    fontSize: '11px',
                    fontFamily: 'Inter Regular',
                    backgroundColor: '#F1F1F1',
                  }}
                >
                  {el.search_key_words?.join(', ')}
                </div>
              )}
            </div>
          </div>
        ))}

      {showLoadMoreButton && filteredRestaurantList.length > 3 && (
        <AtomicButton
          label='Load more restaurants...'
          handleSubmit={onLoadMore}
          style={{
            width: '240px',
            height: '25px',
            margin: '10px 0px 10px 20%',
            border: '1px solid lightgrey',
            backgroundColor: '#f4f5f6',
            color: 'grey',
            fontStyle: 'normal',
            fontSize: '12px',
          }}
          loading={false}
        />
      )}
    </div>
  );
};

export default RestaurantsMobile;
